module.exports = __webpack_public_path__ + "static/media/d3kz.0801ef11.pdf";